(function () {
	'use strict';

	window.js = window.js || {};
	js.contactList = (function () {
		var _domElm;
		var _contactCategories;
		var _filterActivator;

		function filterClickHandler() {
			var selectedId = window.utils.getSelectedOptionValues('filter-contacts');
			_contactCategories.forEach(function (c) {
				c.classList.remove('active');
			});
			var activeCat = _domElm.querySelector('[data-tabid="' + selectedId + '"]');
			if (activeCat) {
				activeCat.classList.add('active');
			}
		}

		function initialize(domElm) {
			_domElm = domElm;
			_contactCategories = Array.prototype.slice.call(_domElm.querySelectorAll('.js-contact__category-container'));
			_filterActivator = _domElm.querySelector(".js-filters__dropdown-activator");
			
			var filters = _domElm.querySelector('.js-filters__list');
			if (filters) {
				filters.addEventListener('click', filterClickHandler);
			}

			if (_contactCategories.length > 0) {
				_contactCategories[0].classList.add('active');
				_filterActivator.innerText = _contactCategories[0].dataset.categoryName;
			}

			_domElm.addEventListener('click', function (e) {
				if (e.target.classList.contains('js-filters__dropdown-activator')) {
					e.preventDefault();
					var elm = document.querySelector(".js-filters__list");
					if (elm.classList.contains("active")) {
						elm.classList.remove("active");
						elm.setAttribute('style', '');
						e.target.parentElement.classList.remove('filters--active');
					} else {
						elm.classList.add("active");
						elm.setAttribute('style', 'height:' + (elm.clientHeight + 1) + 'px');
						e.target.parentElement.classList.add('filters--active');
					}
				}
				if (e.target.classList.contains('js-filters__option')) {
					var filterList = _domElm.querySelector(".js-filters__list");
					if (filterList) {
						filterList.classList.remove("active");
						filterList.setAttribute('style', '');
						console.log(e.target);
						_filterActivator.innerText = e.target.dataset.categoryName;
					}
				}
			});
		}

		return {
			initialize: initialize
		};
	})();


})();